import { gql } from '@apollo/client';

export const ADD_REMOVE_RESOURCE = gql`
  mutation AddRemoveGroupResouceAccessv2($input: addRemoveResourceAccessGroupInput!) {
    addRemoveGroupResouceAccessv2(input: $input) {
      message
      item
      isSuccess
    }
  }
`;
